<template>
  <div
    :class="[
      $style['news-notify-popup-slot-wrap'],
      type === 'news' ? $style['news-notify-popup-slot-wrap--news'] : '',
      type === 'support_hint' ? $style['news-notify-popup-slot-wrap--elastic'] : '',
      (type === 'demo_sidebar' || type === 'support_hint') && isSidebarCollapsed ? $style['news-notify-popup-slot-wrap--sidebar'] : '',
      (type === 'demo_sidebar' || type === 'support_hint') && !isSidebarCollapsed ? $style['news-notify-popup-slot-wrap--sidebar-expanded'] : ''
    ]"
    @click="$emit('onClick', $event)"
    @mouseover="$emit('onMouseOver', $event)"
    @mouseleave="$emit('onMouseLeave', $event)"
  >
    <svg-sprite
      :class="$style['demo_modal__closer']"
      name="close-4"
      :size="24"
      @onClick="$emit('onClose')"
    />
    <div
      :class="$style['demo_modal__container']"
    >
      <div :class="$style['container_view']">
        <div
          v-if="imageSrc"
          :class="$style['view_img_container']"
          :style="{ backgroundColor: imgContainerBg }"
        >
          <div :class="$style['view_img']">
            <img
              :class="{ rounded: isRoundedImg }"
              :src="imageSrc"
            >
          </div>
        </div>
        <div
          :class="$style['view_content']"
        >
          <div
            ref="titleRef"
            :class="$style['content_title']"
          >
            {{ title }}
          </div>
          <div :class="$style['content_text']">
            {{ content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NotifyPopupSlot',
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    content: {
      type: String,
      default: '',
      required: true,
    },
    imageSrc: {
      type: String,
      default: '',
      required: true,
    },
    isRoundedImg: {
      type: Boolean,
      default: false,
    },
    imgContainerBg: {
      type: String,
      default: '#ffffff',
    },
    type: {
      type: String,
      default: '',
    },
    isSidebarCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onClick', 'onMouseOver', 'onMouseLeave', 'onClose'],
};
</script>

<style lang="less" module src="./less/notifyPopupSlot.less">
</style>
